import { combineReducers } from 'redux';
import auth from './auth';

import fetchICData from './fetchICData';
import downloadSource from './downloadSource';
import fetchJobsData from "./fetchJobsData";
import saveCalcDetailsData from "./saveCalcDetailsData";
import fetchColumnMetadata from "./fetchColumnMetadata";
import saveJobData from "./saveJobData";


export default combineReducers({
  auth,
  fetchICData,
  downloadSource,
  fetchJobsData,
  saveCalcDetailsData,
  fetchColumnMetadata,
  saveJobData
});
